import { RouteComponentProps, withRouter } from 'react-router-dom';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import * as React from 'react'
import { inject, observer } from 'mobx-react';
import {
    Drawer,
    Grid,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    Button,
    Tooltip,
    TablePagination, InputAdornment
} from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action, computed } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import AddIcon from '@material-ui/icons/Add';
import Objednavka from 'src/models/Objednavka';
import moment from 'moment'
import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import Turnus from 'src/models/Turnus';
import Klient from 'src/models/Klient';
import { OrderHelper } from 'src/classes/OrderHelper';
import ClientSelectionDialog from './ClientSelectionDialog';
import ClientNewDialog from './ClientNewDialog';
import NovaObjednavka from "../models/NovaObjednavka";
import SearchIcon from "@material-ui/icons/Search";
import removeAccents from "remove-accents";
import ClearIcon from '@material-ui/icons/Clear';

export interface IOrderProps extends RouteComponentProps<any> {
    objednavkaStore?: ObjednavkaStore;
    turnusStore?: TurnusStore;
    klientStore?: KlientStore;
}

@inject('objednavkaStore')
@inject('turnusStore')
@inject('klientStore')
@observer
class Orders extends React.Component<IOrderProps>{

    constructor(props: Readonly<IOrderProps>) {
        super(props);
        console.log("LOAD: Orders");
    }

    // GUI state monitoring
    @observable private isDrawerOpened: boolean = false;
    @observable private isClientSelectionDialogOpen: boolean = false;
    @observable private isNewClientDialogOpened: boolean = false;

    @observable private page = 0;
    @observable private rowsPerPage = 10;

    @observable private filterText = '';
    private filteredAmount = 0;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    @action
    private handleAddOrder = event => {
        this.isClientSelectionDialogOpen = true;
    }

    @action
    private clientSelected = (klient: Klient) => event => {
        this.props.history.push(`/neworder/` + klient.id);
    }
    
    @action
    private handleDialClose = name=> event => {
        this[name] = !this[name];
    }

    private getOrderNames(orderId: number): string {
        const names: string[] = [];
        const trnss: Turnus[] = this.props.turnusStore.getTurnusyByObjednavkaID(orderId);
        const mapa: Map<number, string> = new Map();
        trnss.forEach(trns => {
            const klient: Klient = this.props.klientStore.getClientById(trns.idKlient);
            const name = klient.jmeno + ' ' + klient.prijmeni;
            mapa.set(klient.id, name);
        });
        mapa.forEach(name => {
            names.push(name);
        });
        return names.join(', ');
    }

    private handleOrderClick = order => evt => {
        this.props.history.push(`/orders/${order.id}`)
    }

    public onClientDialogClose = () => {
        this.isNewClientDialogOpened = false;
    }

    public onClientAddNewOrder = (client: Klient) => {
        const klient = this.props.klientStore.createNewClientSimple(client);
        klient.then(kl => {
            this.isNewClientDialogOpened = false;
            const newObj = new NovaObjednavka();
            newObj.addNewClient(client);
            this.props.objednavkaStore.orderTemplate = newObj;
            this.props.history.push(`/neworder`);
            // this.props.history.push(`/neworder/` + kl.id);
        });
    }

    public onNewClientAdd = () => {
        this.isClientSelectionDialogOpen = false;
        this.isNewClientDialogOpened = true;
    }

    public getOrdersPaged = () => {
        const filtered = this.props.objednavkaStore.objednavky.filter((obj: Objednavka) => {
            const names: string = this.getOrderNames(obj.id);
            const namesToFilter: string = this.replaceDiacritics(names).toLowerCase();
            const filter: string = this.replaceDiacritics(this.filterText).toLowerCase();
            if(namesToFilter.includes(filter)) {
                return true;
            }
            return false;
        })
        const sorted = filtered.sort((a, b) => (b.id - a.id))
        this.filteredAmount = sorted.length
        return sorted.slice(this.rowsPerPage * this.page, this.rowsPerPage * this.page + this.rowsPerPage);
    }

    private handlePageChange = (event, page) => {
        console.log("Orders.handlePageChange: page " + page);
        this.page = page;
    }

    private handleFilterChange = (event) => {
        this.filterText = event.target.value;
    }

    private replaceDiacritics(text: string) {
        return removeAccents(text);
    }

    private clearFilter = (event) => {
        this.filterText = '';
    }

    public render() {
        const data = this.getOrdersPaged();
        return (
            <div>
                <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                    <NavigationDrawerItems />
                </Drawer>

                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <AppBar position="static" >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                    <MenuIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit"  style={{ flexGrow: 1 }}>
                                    Objednávky
                                </Typography>
                                {this.filterText.trim() !== '' ?
                                <Tooltip title="Vyčistit filtr" aria-label="Vyčistit filtr">
                                    <IconButton
                                        color="inherit"
                                        aria-label="Vyčistit filtr"
                                        onClick={this.clearFilter}>
                                        <ClearIcon />
                                    </IconButton>
                                </Tooltip> : ""}
                                <TextField
                                    id="input-with-icon-textfield"
                                    value={this.filterText}
                                    onChange={this.handleFilterChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }} />
                                <Tooltip title="Nová objednávka" aria-label="Nová objednávka">
                                    <IconButton color="inherit" aria-label="Nová objednávka" onClick={this.handleAddOrder}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Toolbar>
                        </AppBar>
                    </Grid>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <Paper>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Id</TableCell>
                                        <TableCell>Klienti</TableCell>
                                        <TableCell>Stav</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.map(order => (
                                            <TableRow hover key={order.id} onClick={this.handleOrderClick(order)}>
                                                <TableCell>{order.id}</TableCell>
                                                <TableCell>{this.getOrderNames(order.id)}</TableCell>
                                                <TableCell>{OrderHelper.prettyPrintState(order.stav)}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                            <TablePagination
                                count={this.filteredAmount}
                                rowsPerPageOptions={[]}
                                rowsPerPage={this.rowsPerPage}
                                page={this.page}
                                onChangePage={this.handlePageChange}
                             />
                        </Paper>
                    </Grid>
                </Grid>
                    <ClientSelectionDialog 
                        open={this.isClientSelectionDialogOpen} 
                        onClose={this.handleDialClose('isClientSelectionDialogOpen')} 
                        onSelect={this.clientSelected}
                        onNewSelect={this.onNewClientAdd}
                        title="Nová objednávka pro:" />
                    <ClientNewDialog open={this.isNewClientDialogOpened} onAdd={this.onClientAddNewOrder} onClose={this.handleDialClose('isNewClientDialogOpened')} />
            </div>
        );
    }
}

export default withRouter(Orders);


// WEBPACK FOOTER //
// ./src/components/Orders.tsx